import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { ConsentContainer } = await import('./index');
    return {
        Component: ConsentContainer,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
